import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { TArrayCodec, array } from "../../../shared/src/codecs/types/array";
import { TFormCodec, form } from "../../../shared/src/codecs/types/form";
import { TRequiredCodec, required } from "../../../shared/src/codecs/types/required";
import { TAnyStringCodec, string } from "../../../shared/src/codecs/types/string";
import {
    RoadblockAssigneeRole,
    TRoadblockAssigneeRoleCodec,
} from "../../roadblocks/roadblockAssigneeRoles";
import { EmptyObject, TEmptyObjectCodec } from "../EmptyObject";
import { RoadblockType, TRoadblockTypeCodec } from "./RoadblockForm";

export const RoadblockAssignment: TRequiredCodec<{
    roadblock_type: TRoadblockTypeCodec,
    assignee_role: TRoadblockAssigneeRoleCodec,
}> = required({
    roadblock_type: RoadblockType,
    assignee_role: RoadblockAssigneeRole,
});
export type TRoadblockAssignmentCodec = typeof RoadblockAssignment;
export type TRoadblockAssignment = TTypeOfCodec<TRoadblockAssignmentCodec>;

export const RoadblockAssignmentForm: TFormCodec<
    TRoadblockAssignmentCodec,
    TRequiredCodec<{
        display_name: TAnyStringCodec,
    }>
> = form(
    RoadblockAssignment,
    required({
        display_name: string(),
    }),
);
export type TRoadblockAssignmentFormCodec = typeof RoadblockAssignmentForm;
export type TRoadblockAssignmentForm = TTypeOfCodec<TRoadblockAssignmentFormCodec>;

export const RoadblockAssignmentPageForm: TFormCodec<
    TEmptyObjectCodec,
    TRequiredCodec<{
        roadblock_assignment_forms: TArrayCodec<TRoadblockAssignmentFormCodec>,
    }>
> = form(
    EmptyObject,
    required({
        roadblock_assignment_forms: array(RoadblockAssignmentForm),
    }),
);
export type TRoadblockAssignmentPageFormCodec = typeof RoadblockAssignmentPageForm;
export type TRoadblockAssignmentPageForm = TTypeOfCodec<TRoadblockAssignmentPageFormCodec>;
